import { invariant } from "@exonn/utils";
import type {
  CreateStockMoveFormMeta,
  CreateVariantFormMeta,
} from "src/framework/types.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const createResourceStorageKeys = ({
  resource,
}: {
  resource: string;
}) => {
  return {
    listState: {
      name: [resource, "list", "state"].join("."),
      version: "1",
    },
    listExpandedRows: {
      name: [resource, "list", "expandedRows"].join("."),
      version: "1",
    },
    form: ({
      id,
      type,
      tab,
      meta,
    }: {
      id?: string;
      type: "edit" | "create";
      tab?: string;
      meta?: any;
    }) => {
      invariant(
        type !== "edit" || !!id,
        "id must be specified for storage key of edit form",
      );

      const createStockMoveMeta = meta as CreateStockMoveFormMeta | undefined;

      if (
        type === "create" &&
        resource === ResourceEnum.StockMove &&
        createStockMoveMeta?.insideVariantForm
      ) {
        return {
          name: [resource, "form", type, meta.variantSku].join("."),
          version: "4",
        };
      }

      const createVariantMeta = meta as CreateVariantFormMeta | undefined;

      if (type === "create" && resource === ResourceEnum.Variant) {
        return {
          name: [resource, "form", type, createVariantMeta?.product_id].join(
            ".",
          ),
          version: "4",
        };
      }

      if (type === "create") {
        return {
          name: [resource, "form", type, id, tab ?? "general"].join("."),
          version: "4",
        };
      } else {
        return {
          name: [resource, "form", type, id, tab ?? "general"].join("."),
          version: "4",
        };
      }
    },
    formLang: ({
      id,
      type,
      tab,
    }: {
      id?: string;
      tab?: string;
      type: "edit" | "create";
      meta?: any;
    }) => {
      invariant(
        type !== "edit" || !!id,
        "id must be specified for storage key of edit form",
      );
      return {
        name: [resource, "form", type, id, tab ?? "general", "lang"].join("."),
        version: "4",
      };
    },
    tabs: {
      name: [resource, "tabs"].join("."),
      version: "1",
    },
  };
};
